








































import { Component, Vue, Mixins } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { jobDetailsLocalisationKeys } from '@/features/job/job.localisation'
import Notification from '@/shared/Notification.mixin.vue'
import { JOB_LIST_NAME } from '@/features/job/job.router'
import { Dictionary } from 'vue-router/types/router'
import { IActionType } from '@/system/store'
import { REMOVE_JOB } from '@/system/store/action-types'
import { GET_JOB_LIST } from '@/system/store/getter-types'
import { IJob } from '@/features/job/store'
import debounce from 'lodash.debounce'

@Component
export default class RemoveJobDialog extends Mixins(Notification) {
  private translations = jobDetailsLocalisationKeys
  private showDialog: boolean = false
  private typedText: string = ''

  @Action(REMOVE_JOB)
  removeJob!: IActionType
  @Getter(GET_JOB_LIST)
  jobList!: IJob[]

  public openDialog (): void {
    this.showDialog = true
  }

  private get textForConfirm (): string {
    return this.$t(this.translations.TEXT_CONFIRM_FOR_DELETE) as string
  }

  private handleRemove (): void {
    if (this.textForConfirm !== this.typedText) {
      return this.showError(this.$t(this.translations.NOT_VALID_CONFIRM_TEXT) as string)
    }

    const { uuid } = this.$route.params as Dictionary<'uuid'>

    this.removeJob({ uuid, jobList: this.jobList })

    debounce(() => {
      return this.$router.push({ name: JOB_LIST_NAME, params: { removedJobId: uuid } })
    }, 1000)()
  }
}
